import { render } from "./InquiryCreateForm.vue?vue&type=template&id=b1841892&lang=true"
import script from "./InquiryCreateForm.vue?vue&type=script&lang=js"
export * from "./InquiryCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__